/**
 * Mirrors @zoom/videosdk subsession enums (see dist/types/common.d.ts / subsession.d.ts).
 * Defined locally so Jest and bundlers always resolve stable values; named imports from
 * the Zoom CJS bundle can be undefined in the test runtime.
 */
export enum SubsessionStatus {
    NotStarted = 1,
    InProgress = 2,
    Closing = 3,
    Closed = 4
}

export enum SubsessionUserStatus {
    Initial = 'initial',
    Invited = 'invited',
    Joining = 'joining',
    InSubsession = 'in room',
    Leaving = 'leaving',
    MainSession = 'main session'
}

export enum SubsessionAllocationPattern {
    Automatically = 1,
    Manually = 2
}
